import { Component, inject } from '@angular/core';
import { ExchangeTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ExchangeTypeCreateDto,
  ExchangeTypeDto,
  ExchangeTypeExcelDownloadDto,
  ExchangeTypeUpdateDto,
} from '../proxy/controlling/dtos/exchange-type';
import { EXCHANGETYPE_CONFIG, EXCHANGETYPE_FIELDS } from './exchange-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-exchange-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ExchangeTypeService, ConfirmationService],
  templateUrl: './exchange-type.html',
  styleUrl: './exchange-type.scss',
})
export class ExchangeType extends BaseCrudComponent<
  ExchangeTypeDto,
  ExchangeTypeCreateDto,
  ExchangeTypeUpdateDto,
  ExchangeTypeExcelDownloadDto
> {
  service = inject(ExchangeTypeService);
  config = EXCHANGETYPE_CONFIG;
  fields = EXCHANGETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ExchangeTypeDto): ExchangeTypeUpdateDto {
    return {
      value: data.value,
      documentDate: data.documentDate,
      currencyId: data.currencyId,
      rowVersion: selected.rowVersion,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ExchangeType';
  }
}
